export default __webpack_public_path__ + "static/10-a3cf99cb1cd1544e9f9e7fdff8e6e4ec.webp";